import { render, staticRenderFns } from "./AnfangsBild.vue?vue&type=template&id=3e4c8962"
import script from "./AnfangsBild.vue?vue&type=script&lang=js"
export * from "./AnfangsBild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports